/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ColorMessageVMBehavior", ["ColorVMBehavior"], function (context, cls) {
  /**
   * @class ColorMessageVMBehavior
   * @memberOf classes
   * @extends classes.ColorVMBehavior
   */
  cls.ColorMessageVMBehavior = context.oo.Singleton(cls.BehaviorBase, function ($super) {
    return /** @lends classes.ColorMessageVMBehavior.prototype */ {
      __name: "ColorMessageVMBehavior",

      watchedAttributes: {
        anchor: ["color", "reverse", "type"]
      },

      _watchThemeChanged: true,

      /**
       * Applies the color only if it has been defined by the VM, use default value otherwise.
       */
      _apply: function (controller, data) {
        const messageNode = controller.getAnchorNode();
        const kind = messageNode.attribute("type") === "error" ? "error" : "message";
        let color = messageNode.getStyleAttribute("textColor", [kind]);
        const widget = controller.getWidget();
        if (widget.setMessageKind) {
          widget.setMessageKind(kind);
        }

        if (color) {
          widget.setColor(color);
        } else if (messageNode.isAttributeSetByVM("color")) {
          const isReverse = messageNode.attribute("reverse") === 1;

          if (messageNode.attribute("color") === "white") {
            color = context.ThemeService.getValue("gbc-MessageWidget-color");
          } else {
            color = isReverse ? messageNode.getStyleAttribute("textColor") : messageNode.attribute("color");
          }
          widget.setColor(context.ThemeService.resolveThemedColor(color, isReverse));
        } else {
          widget.setColor(context.ThemeService.getValue("gbc-MessageWidget-color"));
        }
      }
    };
  });
});
